import { TimePicker, TimePickerProps } from '@material-ui/pickers';
import * as React from 'react';
import * as constants from '@app/constants';

const defaultProps: TimePickerProps = {
	format: constants.timePickerFormat,
	inputVariant: 'outlined',
	fullWidth: true,
	ampm: false,
	onChange: () => null,
	value: '',
};

const CustomTmePicker: React.FunctionComponent<TimePickerProps> = (props) => {
	return <TimePicker {...props} />;
};

CustomTmePicker.defaultProps = defaultProps;

export default CustomTmePicker;



// WEBPACK FOOTER //
// ./src/components/shared/custom-time-picker.component.tsx